import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
//import config from '../public/config/config';
import store from './store';
import mixin  from './mixin';
import VModal from 'vue-js-modal';
import axios from 'axios';
//axios.defaults.baseURL = 'http://' + config.env.IP_ADRESS + ':' + config.env.PORT + '/api'
axios.defaults.baseURL = 'https://control.videochatroom.net/api'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.mixin(mixin);
Vue.use(VModal);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
